import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import {
  RoomAccountEffects,
  RoomEffects,
  RoomEventsEffects,
  RoomLicenseEffects,
  RoomLiveEffects,
  RoomLiveStreamStatusEventsEffects,
  RoomMixerEffects,
  RoomMixerStreamEffects,
  RoomProducerCamMicEffects,
  RoomProducerPublishEffects,
  RoomRemoteStreamsEffects,
  RoomV2Effects,
  RoomYoumAPIEffects
} from "./+state/effects";
import { RoomAccountService, RoomService } from "./+state/services";

// Only 'studio' app supports socket connection,
// separate effects and services that depends on socket.

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([
      RoomAccountEffects,
      RoomEventsEffects,
      RoomLicenseEffects,
      RoomLiveEffects,
      RoomProducerCamMicEffects,
      RoomProducerPublishEffects,
      RoomRemoteStreamsEffects,
      RoomYoumAPIEffects,
      RoomEffects,
      RoomV2Effects,
      RoomMixerEffects,
      RoomMixerStreamEffects,
      RoomLiveStreamStatusEventsEffects
    ])
  ],
  providers: [RoomAccountService, RoomService]
})
export class RoomStudioDataAccessModule {}
